import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-atlas",
  "use": "icon-soc-atlas-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-atlas\">\r\n<g transform=\"translate(-113.571 -113.571) scale(1.221818)\">\r\n<path d=\"M160 224h704v576H160V224zm96 96v384h512V320H256z\" />\r\n  <path d=\"M384 416a64 64 0 1 1 0 128 64 64 0 0 1 0-128zm192 64l128-96 64 48-128 160H512l64-112z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-atlas.svg
// module id = QTNl
// module chunks = 488